import { useContext } from 'react';
import { SelectedObjectsContext } from '../context';

export const useSelectObjectsEnabled = () => {
  const selectedCtx = useContext(SelectedObjectsContext);

  return !!selectedCtx;
};